import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Constants } from '@app/constants';
import { LoggingService } from '@app/core/services/logging.service';
import { SessionTimeoutActions } from '@app/models/session-timeout-actions';
import { interval } from 'rxjs';
import { map, scan } from 'rxjs/operators';
@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.scss']
})
export class SessionTimeoutComponent implements OnInit, AfterViewInit {
  timer$;

  constructor(
    public dialogRef: MatDialogRef<any>,
    private ls: LoggingService
  ) {}

  ngOnInit(): void {
    this.timer$ = interval(1000).pipe(
      map(() => 1),
      scan((acc, init) => acc - init, Constants.appConfiguration.timeout),
      map(num => num + ' sec')
    );
  }
  signout(): void {
    this.dialogRef.close(SessionTimeoutActions.SIGN_OUT);
  }
  resetIdle(): void {
    this.dialogRef.close(SessionTimeoutActions.RESET);
  }
  ngAfterViewInit(): void {
    this.ls.sendInfoLevelMessage('Session time out page loaded successfully');
  }
}
